import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_AFF_BALANCES = Symbol('aff-balances');

export const AFFILIATE_BALANCES_ROUTE_NAME = Symbol('affiliate.balances');
export const AFFILIATE_BALANCES_LIST_ROUTE_NAME = Symbol('affiliate.balances.list');

export const AFF_BALANCES_LIST_URL = 'affiliate/cashouts/list';
export const AFF_BALANCES_LIST_QUERY_KEY = 'aff-balances.list';

export const AFFILIATE_BALANCE_URL = 'affiliate/cashouts/current_balance';
export const AFFILIATE_BALANCE_QUERY_KEY = 'affiliate.balance';

export const AFF_BALANCES_DOWNLOAD_REPORT_URL = 'affiliate/cashouts/download_report';
export const AFF_BALANCES_DOWNLOAD_REPORT_MUTATION_KEY = 'aff-balances.report';

export const AFF_BALANCES_PERMISSIONS = {
  SHOW: new Permission(undefined, PermissionsList.affiliate.CASHOUTS_LIST),
  DOWNLOAD_LIST: new Permission(undefined, PermissionsList.affiliate.CASHOUTS_DOWNLOAD_REPORT),
  SHOW_BALANCE: new Permission(undefined, PermissionsList.affiliate.CASHOUTS_SHOW_BALANCE),
  WITHDRAW: new Permission(undefined, PermissionsList.affiliate.CASHOUTS_WITHDRAW),
};
